import { HeldEmailQueueDialogs } from "./HeldEmailQueueDialogs";
import { HeldEmailQueueViewModel } from "./heldEmailQueueViewModel";

export function HeldEmailQueueDialogsForView({
  model,
}: {
  model: HeldEmailQueueViewModel;
}) {
  return (
    <HeldEmailQueueDialogs
      dispatch={model.dispatch}
      emails={model.data?.data ?? []}
      state={model.state}
    />
  );
}
